import { useMutation } from "react-query";
import { importOrUpdateFleet } from "store/api/api";
import { handleAxiosError } from "store/util";
import { CreateUpdateFleetData } from "types/types";
import { MUTATION_KEYS } from "../queryKeys";

const createFleet = async (params: CreateUpdateFleetData) => {
  return await importOrUpdateFleet(params);
};

export function useCreateFleet() {
  return useMutation(createFleet, {
    mutationKey: MUTATION_KEYS.createFleet,

    onError: (err) => {
      handleAxiosError(err);
    },
  });
}
